const PREFIX = 'ADVERTISEMENT'

export const ADVERTISEMENT_GET = `${PREFIX}_GET`
export const ADVERTISEMENT_CLEAR = `${PREFIX}_CLEAR`
export const ADVERTISEMENT_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const TOGGLE_POST_EDIT_MODAL = `${PREFIX}_TOGGLE_POST_EDIT_MODAL`
export const TOGGLE_POST_DELETE_MODAL = `${PREFIX}_TOGGLE_POST_DELETE_MODAL`
export const SET_MY_POSTS = `${PREFIX}_SET_MY_POSTS`
export const SET_TYPE_POSTS = `${PREFIX}_SET_TYPE_POSTS`
